var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import URI from 'urijs';
import { HITLBase } from './HITLBase';
export class Listeners extends HITLBase {
    static getListeners(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const params = _.omit(options, ['version']);
            return this.request({
                method: 'GET',
                route,
                params,
            });
        });
    }
    static getListenerById(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(options.callbackId).href();
            const params = _.pick(options, ['agentId']);
            return this.request({
                method: 'GET',
                route,
                params,
            });
        });
    }
    static createListener(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const data = _.omit(options, ['version']);
            return this.request({
                method: 'POST',
                route,
                data,
            });
        });
    }
    static updateListener(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(options.callbackId).href();
            const data = _.omit(options, ['callbackId', 'version']);
            return this.request({
                method: 'PUT',
                route,
                data,
            });
        });
    }
    static deleteListener(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(options.callbackId).href();
            return this.request({
                method: 'DELETE',
                route,
            });
        });
    }
}
Listeners.MODULE_URL = 'listeners';
//# sourceMappingURL=Listeners.js.map